import React, { useCallback, useEffect, useState } from "react";

import FormSelectList from "../../../../../containers/forms/form-select-list";
import { useFormsListMetadataByFormId } from "../../../../../hooks/form";
import useDebounce from "../../../../../hooks/useDebounce";
import { language } from "../../../../../language";
import GenericModal from "../../../../modal-closebtn/index";

const ModelerModalFormList = ({
  FormComponents,
  saveFormOnSelect,
  businessObject,
  element,
  extensionElements,
  selectBox,
  bpmnFactory,
}) => {
  const [open, setOpen] = useState(true);
  const [formValues, setFormValues] = useState(null);
  const debouncedFormValues = useDebounce(formValues, 500);

  const { data: formListData, refetch: fetchFormList } =
    useFormsListMetadataByFormId({
      enabled: !!debouncedFormValues,
      body: debouncedFormValues,
    });

  useEffect(() => {
    if (debouncedFormValues) {
      fetchFormList && fetchFormList();
    }
  }, [debouncedFormValues, fetchFormList]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = useCallback(() => {
    const obj = [];
    if (formValues && formListData) {
      formValues.forEach((info) => {
        const form = formListData.find((item) => item.id === info.form);
        if (form) {
          obj.push({ form });
        }
      });
    }

    saveFormOnSelect(
      businessObject,
      element,
      extensionElements,
      selectBox,
      bpmnFactory,
      obj,
    );
    handleClose(false);
  }, [formValues, formListData]);

  const handleSelect = useCallback((selecteds) => {
    const data = [];

    for (const selection of selecteds) {
      data.push({ form: selection[0] });
    }
    setFormValues(data);
  }, []);

  return (
    open && (
      <>
        <GenericModal
          title={language.listFormMenu}
          handleClose={handleClose}
          size="xl"
          bigHeight
          open={true}
        >
          <FormSelectList
            handleSave={handleSave}
            handleSelect={handleSelect}
            selectedForms={FormComponents}
          />
        </GenericModal>
      </>
    )
  );
};

export default ModelerModalFormList;
